import { AxiosPromise } from 'axios';
import { gfhAPI } from 'API/httpClient';

function getPaymentInfo({
  countryCode,
  userId,
}: {
  countryCode: string;
  userId: string;
}): AxiosPromise<GfhPaymentInfo> {
  return gfhAPI.get(
    '/payment/get-payment-info?userId=:userId&ip=:ip&country=:countryCode'
      .replace(':userId', userId)
      .replace(':ip', '0.0.0.0')
      .replace(':countryCode', countryCode)
  );
}

export default getPaymentInfo;
